export default __webpack_public_path__ + "static/media/listView.dbf1bb09.svg";